import type React from 'react';

import { MembershipAwarenessSunrise } from '../components/MembershipAwarenessSunrise';
import { useMembershipAwarenessFormData } from '../formContext';
import { useMembershipExists } from '../shared/hooks/useMembershipExists';
import type { Props } from '../shared/types';

export const MembershipAwarenessContainerSunrise: React.FC<Props> = (props) => {
	const {
		data: {
			featureConfigs: { membershipEnabled },
		},
	} = useMembershipAwarenessFormData();
	const membershipExists = useMembershipExists();
	if (!membershipEnabled || membershipExists) return null;

	return <MembershipAwarenessSunrise {...props} />;
};
